import React from 'react';
import {t} from "i18next";

export default function ValidationMessage(props) {
  return (
    <div className="validation-message invalid-feedback">
      <span>{t(props.children)}</span>
    </div>
  );
}
